import { render, staticRenderFns } from "./settings-timeline.vue?vue&type=template&id=5264e0fa&"
import script from "./settings-timeline.vue?vue&type=script&lang=js&"
export * from "./settings-timeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "settings-timeline.vue"
export default component.exports